$(() => {
  $(document).ready(function () {
    const dashboardWrapper = $(".dashboard-wrapper");
    const handleProductInfo = () => {
      const productName = $(".dashboard-product-name").text().toLowerCase();

      if (productName.indexOf("general liability") !== -1) {
        $(".gl-insurance-info").css("display", "flex");
      }
      if (productName.indexOf("professional liability") !== -1) {
        $(".pl-insurance-info").css("display", "flex");
      }
      if (productName.indexOf("equipment and small tools") !== -1) {
        $(".im-insurance-info").css("display", "flex");
      }
    };

    if (dashboardWrapper.length > 0) {
      window.onscroll = function () {
        if (document.documentElement.scrollTop > $("header").height()) {
          dashboardWrapper.addClass("is-pinned");
        } else {
          dashboardWrapper.removeClass("is-pinned");
        }
      };
    }

    handleProductInfo();
  });
});
